import { render, staticRenderFns } from "./QuotationFiles.vue?vue&type=template&id=671f0fc6&scoped=true&lang=pug&"
import script from "./QuotationFiles.vue?vue&type=script&lang=js&"
export * from "./QuotationFiles.vue?vue&type=script&lang=js&"
import style0 from "./QuotationFiles.vue?vue&type=style&index=0&id=671f0fc6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671f0fc6",
  null
  
)

export default component.exports